import React from 'react';
import styled from 'styled-components';
import { Card, CardContent, Typography, Avatar, Button } from '@mui/material';
import { useSelector } from 'react-redux';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

const TeacherProfile = () => {
  const { currentUser, response, error } = useSelector((state) => state.user);

  if (response) console.log(response);
  else if (error) console.log(error);

  const teachSclass = currentUser.teachSclass;
  const teachSubject = currentUser.teachSubject;
  const teachSchool = currentUser.school;

  return (
    <ProfileContainer>
      <ProfileCard>
        <ProfileHeader>
          <AvatarContainer>
            <Avatar sx={{ width: 90, height: 90, background: 'gold' }}>
              <AccountCircleIcon sx={{ fontSize: 70, color: '#004d40' }} />
            </Avatar>
          </AvatarContainer>
          <ProfileName variant="h5">{currentUser.name}</ProfileName>
          <ProfileEmail variant="body2">{currentUser.email}</ProfileEmail>
        </ProfileHeader>
        <ProfileCardContent>
          <ProfileText>Class: {teachSclass.sclassName}</ProfileText>
          <ProfileText>Subject: {teachSubject.subName}</ProfileText>
          <ProfileText>School: {teachSchool.schoolName}</ProfileText>
          <StyledButton>Thank You</StyledButton>
        </ProfileCardContent>
      </ProfileCard>
    </ProfileContainer>
  );
};

export default TeacherProfile;

const ProfileContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: linear-gradient(135deg, #004d40, #009688);
  padding: 20px;
`;

const ProfileCard = styled(Card)`
  width: 100%;
  max-width: 400px;
  border-radius: 20px;
  box-shadow: 0px 6px 25px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  background: #fff;
  text-align: center;
  transition: transform 0.3s ease-in-out;
  &:hover {
    transform: scale(1.05);
  }
`;

const ProfileHeader = styled.div`
  background: linear-gradient(135deg, gold, #b8860b);
  color: #004d40;
  padding: 40px 20px;
  border-bottom-left-radius: 50% 25px;
  border-bottom-right-radius: 50% 25px;
`;

const AvatarContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
`;

const ProfileName = styled(Typography)`
  font-weight: bold;
  font-size: 22px;
`;

const ProfileEmail = styled(Typography)`
  font-size: 14px;
  opacity: 0.8;
`;

const ProfileCardContent = styled(CardContent)`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 25px;
`;

const ProfileText = styled(Typography)`
  margin: 12px 0;
  font-size: 18px;
  color: #004d40;
  font-weight: 600;
`;

const StyledButton = styled(Button)`
  margin-top: 15px;
  background: gold !important;
  color: #004d40 !important;
  font-weight: bold !important;
  padding: 10px 20px !important;
  border-radius: 30px !important;
  transition: all 0.3s ease-in-out;
  &:hover {
    background: #b8860b !important;
    transform: scale(1.1);
  }
`;
